module.exports = __webpack_public_path__ + "img/14.8dd69d1c.jpg";